import { c as _c } from "react/compiler-runtime";
import { ReactElement, memo } from 'react';
import classNames from 'clsx';
import styles from './burger-icon.component.module.scss';
export interface Props {
  activated?: boolean;
}
function BurgerIconComponent(t0) {
  const $ = _c(4);
  const {
    activated: t1
  } = t0;
  const activated = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== activated) {
    t2 = classNames(styles["burger-icon"], {
      [styles["burger-icon--active"]]: activated
    });
    $[0] = activated;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const burgerIconClasses = t2;
  let t3;
  if ($[2] !== burgerIconClasses) {
    t3 = <div className={burgerIconClasses} />;
    $[2] = burgerIconClasses;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
export default memo(BurgerIconComponent);